import "core-js/modules/es.number.constructor";
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-dataV-percentPond",
  inject: ['queryParam'],
  props: {
    width: Number,
    height: Number,
    option: Object
  },
  watch: {
    'option.attribute': {
      handler: function handler() {
        this.loadData();
      },
      deep: true //深度监听

    },
    width: function width() {
      this.refreshFlagKey = require('uuid').v1();
    },
    height: function height() {
      this.refreshFlagKey = require('uuid').v1();
    }
  },
  data: function data() {
    return {
      uuid: null,
      pondConfig: {},
      refreshFlagKey: null //强制刷新视图

    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshFlagKey = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "PercentPond").then(function (res) {
        var tempConfig = JSON.parse(JSON.stringify(_this.option.attribute));
        tempConfig.value = res.value;
        tempConfig.lineDash = [tempConfig.lineWidth, tempConfig.lineSpace];
        _this.pondConfig = tempConfig;
        _this.refreshFlagKey = require('uuid').v1(); //强制刷新视图 报错为dataV组件内部bug
      });
    }
  }
};